module.exports = __webpack_public_path__ + "img/nobus@3x.9c96451f.png";